//import React, { useEffect } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import EditEscrowModal from "../../popups/EditEscrowModal";
// import EditOwnerTitleModal from "../../popups/EditOwnerTitleModal";
// import EditLenderTitleModal from "../../popups/EditLenderTitleModal";
import ControlledField from './ControlledField';
import { computeTitleFeePayorAmount } from '../utils/calculations';

export default function EscrowTitleFields({ mainId, control, FloatingInput, CustomSelect, getValues, setValue, openModal, closeModal, FloatingNumber, cleanNumber, handleCurrencyBlur, onFormatted, EscrowDisabled, onContinue, handleSellerCalculation }) {
  // Debug: optionally log current RHF values when this component mounts
  // useEffect(() => {
  //   try {
  //      //console.log('EscrowTitleFields values:', getValues && getValues('titleSettlementMeta'));
  //   } catch (e) {
  //     // keep safe in case console is unavailable
  //   }
  // }, [getValues]);

  // On-demand rows from the backend (closingCostOverrideService, mode:"title") — e.g. CA
  // City/County Transfer Tax. Not part of the fixed closingCostMeta template; rendered here
  // the same way as Owners/Lenders Title Policy.
  const transferTaxRows = useWatch({ control, name: 'titleSettlementMeta.transferTaxRows' }) || [];

  const onTransferTaxPayorChange = (index, payor) => {
    const row = transferTaxRows[index];
    if (!row) return;
    const amount = computeTitleFeePayorAmount(payor, row.baseAmount);
    setValue(`titleSettlementMeta.transferTaxRows.${index}.payor`, payor);
    setValue(`titleSettlementMeta.transferTaxRows.${index}.amount`, amount);
    try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
  };

  // Metro United Title & Escrow Company
  const recalculateCombinedTitleSalesTax = (overrides = {}) => {
    
    const salesTaxRate =    Number(getValues ? getValues("titleSettlementMeta.salesTaxRate") : 0) || 0;
    let checkState = getValues('addressMeta.state');

    if (String(mainId) !== "5" && checkState !== 'WA' && salesTaxRate === 0) return;
  
    const ownersTitleAmount =
      overrides.ownersTitleAmount ??
      (Number(
        getValues ? getValues("titleSettlementMeta.ownersTitleAmount") : 0
      ) || 0);   

    const combinedTitleSalesTax = ownersTitleAmount * salesTaxRate;
    setValue && setValue("closingCostMeta.9.value", combinedTitleSalesTax);
    setValue && setValue('closingCostMeta.9.type', 'Flat Fee');
  };

  return (
    <>
      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className='lbl-section'>Escrow or Settlement</label>
          <Controller
            name="titleSettlementMeta.escrowSettlementPayor"
            control={control}
            defaultValue={getValues ? getValues('titleSettlementMeta.escrowSettlementPayor') ?? 'Seller' : 'Seller'}
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={getValues ? getValues('titleSettlementMeta.escrowSettlementPayor') : ''}
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    // forward to RHF
                    field.onChange && field.onChange(val);

                    // determine amounts based on selected payor
                    const sellerAmount = Number(getValues ? getValues('titleSettlementMeta.escrowSettlementSeller') : 0) || 0;
                    const splitAmount = Number(getValues ? getValues('titleSettlementMeta.escrowSettlementSplit') : 0) || 0;
                    const payor = String(val || "").toLowerCase();
                    let escrowSettlementAmount = splitAmount;

                    if (payor === 'buyer') {
                      escrowSettlementAmount = 0;
                    } else if (payor === 'seller') {
                      escrowSettlementAmount = sellerAmount;
                    } else {
                      // Split
                      escrowSettlementAmount = splitAmount;
                    }

                    setValue && setValue('titleSettlementMeta.escrowSettlementAmount', escrowSettlementAmount);

                    const salesTaxRate = Number(getValues ? getValues('titleSettlementMeta.salesTaxRate') : 0) || 0;
                    let checkState = getValues('addressMeta.state');
                    // Metro United Title & Escrow Company
                    if (String(mainId) === '5' && checkState === 'WA' && salesTaxRate !== 0) {
                      const sAmount = escrowSettlementAmount * salesTaxRate;
                      setValue && setValue('closingCostMeta.10.value', sAmount);
                      setValue && setValue('closingCostMeta.10.type', 'Flat Fee');
                    }

                    try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }

                  } catch (e) {
                    console.warn(
                      "Failed handling escrowSettlementPayor change",
                      { error: e }
                    );
                  }
                }}
              />
            )}
          />
        </div>        
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group sign-of-amount no-m-space">

              <ControlledField
                name="titleSettlementMeta.escrowSettlementAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={getValues ? getValues('titleSettlementMeta.escrowSettlementAmount') : '0.00'}
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.escrowSettlement}
                className={EscrowDisabled && EscrowDisabled.escrowSettlement === false ? 'premium-border' : ''}
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.escrowSettlementAmount", value);
                  try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                }}
              />


            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Escrow / Settlement Fee",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Escrow Title Policy"
                        onClose={closeModal}
                        onContinue={setting => onContinue({ escrowSettlement: setting })}
                      />
                    )
                  });

                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className="lbl-section">Owners Title Policy</label>
          <Controller
            name="titleSettlementMeta.ownersTitlePayor"
            control={control}
            defaultValue={getValues ? getValues('titleSettlementMeta.ownersTitlePayor') ?? 'Seller' : 'Seller'}
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={getValues ? getValues('titleSettlementMeta.ownersTitlePayor') : ''}
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    field.onChange && field.onChange(val);
                    const sellerAmount = Number(getValues ? getValues('titleSettlementMeta.ownersTitleSeller') : 0) || 0;
                    const payor = String(val || "").toLowerCase();
                    let ownersTitleAmount = sellerAmount / 2;

                    if (payor === 'buyer') {
                      ownersTitleAmount = 0;
                    } else if (payor === 'seller') {
                      ownersTitleAmount = sellerAmount;
                    } else {
                      // Split
                      ownersTitleAmount = sellerAmount / 2;
                    }

                    setValue && setValue('titleSettlementMeta.ownersTitleAmount', ownersTitleAmount);

                    recalculateCombinedTitleSalesTax({ ownersTitleAmount });

                    try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                  } catch (e) {
                    console.warn('Failed handling ownersTitlePayor change', e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group sign-of-amount no-m-space">

              <ControlledField
                name="titleSettlementMeta.ownersTitleAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={getValues ? getValues('titleSettlementMeta.ownersTitleAmount') : '0.0'}
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.ownersPolicy}
                className={EscrowDisabled && EscrowDisabled.ownersPolicy === false ? 'premium-border' : ''}
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.ownersTitleAmount", value);
                  recalculateCombinedTitleSalesTax({
                    ownersTitleAmount: Number(value) || 0,
                  });
                  try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                }}
              />
            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Owners Title Policy",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Owners Title Policy"
                        onClose={closeModal}
                        onContinue={setting => onContinue({ ownersPolicy: setting })}
                      />
                    )
                  });
                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className="lbl-section">Lenders Title Policy</label>
          <Controller
            name="titleSettlementMeta.lendersTitlePayor"
            control={control}
            defaultValue={getValues ? getValues('titleSettlementMeta.lendersTitlePayor') ?? 'Seller' : 'Seller'}
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={getValues ? getValues('titleSettlementMeta.lendersTitlePayor') : ''}
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    field.onChange && field.onChange(val);
                    const sellerAmount = Number(getValues ? getValues('titleSettlementMeta.lendersTitleSeller') : 0) || 0;
                    const payor = String(val || "").toLowerCase();
                    let lendersTitleAmount = sellerAmount / 2;

                    if (payor === 'buyer') {
                      lendersTitleAmount = 0;
                    } else if (payor === 'seller') {
                      lendersTitleAmount = sellerAmount;
                    } else {
                      // Split -> sellers share / 2
                      lendersTitleAmount = sellerAmount / 2;
                    }

                    setValue && setValue('titleSettlementMeta.lendersTitleAmount', lendersTitleAmount);
                   try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                  } catch (e) {
                    console.warn('Failed handling lendersTitlePayor change', e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group no-m-space sign-of-amount">

              <ControlledField
                name="titleSettlementMeta.lendersTitleAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={getValues ? getValues('titleSettlementMeta.lendersTitleAmount') : '0.00'}
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.lendersPolicy}
                className={EscrowDisabled && EscrowDisabled.lendersPolicy === false ? 'premium-border' : ''}
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.lendersTitleAmount", value);
                  
                  try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                }}
              />
            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Lenders Title Policy",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Lenders Title Policy"
                        onClose={closeModal}
                        onContinue={setting => onContinue({ lendersPolicy: setting })}
                      />
                    )
                  });
                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {transferTaxRows.map((row, index) => (
        <div className="calc-frm-field" key={`${row.label}-${index}`}>
          <div className="calc-frm-fld form-group">
            <label className="lbl-section">{row.label}</label>
            <Controller
              name={`titleSettlementMeta.transferTaxRows.${index}.payor`}
              control={control}
              defaultValue={row.payor ?? ''}
              render={({ field }) => (
                <CustomSelect
                  {...field}
                  placeholder={row.payor || 'Select'}
                  options={['Split', 'Buyer', 'Seller']}
                  onChange={(val) => {
                    field.onChange && field.onChange(val);
                    onTransferTaxPayorChange(index, val);
                  }}
                />
              )}
            />
          </div>
          <div className="calc-frm-fld form-group">
            <div className="calc-frm-field">
              <div className="calc-frm-fld form-group sign-of-amount no-m-space">
                <ControlledField
                  name={`titleSettlementMeta.transferTaxRows.${index}.amount`}
                  control={control}
                  InputComponent={FloatingNumber}
                  placeholder="0.00"
                  type="text"
                  defaultValue={row.amount ?? '0.00'}
                  cleanNumber={cleanNumber}
                  onFormatted={(name, value) => {
                    setValue(`titleSettlementMeta.transferTaxRows.${index}.amount`, value);
                    try { handleSellerCalculation && handleSellerCalculation(); } catch (e) { /* ignore */ }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}

    </>
  );
}
